function WebPDTool(element) {
    this.container = element;
    this.btn = this.container.find("#measure_pd");
    this.pdInput = this.container.find("input[name='pd_value']");
    this.serverUrl = "https://api.glasseson.com/prod/";
    this.clientId = clientId;
    this.submitButton = this.container.find('.Form__Submit');

    this.firstName = this.container.find('input[name="firstname"]');
    this.lastName = this.container.find('input[name="lastname"]');
    this.email = this.container.find('input[name="email"]');
    this.pdValue = this.container.find('input[name="pd_value"]');

    this.stepOne = this.container.find('fieldset[data-reactid=".hbspt-forms-0.1:$0"],fieldset[data-reactid=".hbspt-forms-0.1:$1"],fieldset[data-reactid=".hbspt-forms-0.1:$3"]');
    this.stepTwo = this.container.find('fieldset[data-reactid=".hbspt-forms-0.1:$4"]');
    this.nextStepBtn = this.container.find('#next_step');
    this.submitButtonContainer = this.container.find('.hs_submit');

    this.pd_value = 0;

    this.init = function () {

        this.submitButtonContainer.hide();
        this.stepTwo.hide();
        this.initWebPD();
    };

    this.setFormListeners = function () {
        var self = this;
        this.btn.on('click', function (e) {
            e.preventDefault();
            glasseson.open("pd", "pre");
        });

        this.nextStepBtn.on('click', function(e) {
            e.preventDefault();

            if (self.firstName.val() !== '' && self.lastName.val() !== '' && self.email.val() !== '' && self.validateEmail(self.email.val())) {
                self.showNextStep();

                glasseson.open("pd", "pre");
            } else {
                //faking form submission to show error messages
                self.submitButton.click();
            }
        });
    };

    this.initWebPD = function () {
        var self = this;
        var options = {
            fullPage: true,
            width: 835,
            themeColor: "#9e795a",
            fontFamily: "Open Sans, Arial, sans-serif",
            profileName: "web",
            flow: "PD"
        };
        glasseson.init(this.clientId, this.serverUrl, options).then(
            response => {
                self.onPDinit();
            },
            error => {
                self.handleError(error);
            }
        );
    };

    this.onPDinit = function () {
        var self = this;
        glasseson.setResultCallback(function (result) {
            self.assignPDValue(result);
        });
        glasseson.setCloseCallback(function (result) {
            self.handleFlowInterruption(result);
        });
        glasseson.setAnalyticsCallback(function(event) {
            self.handleAnalytics(event);
        });

        this.setFormListeners();
    };

    this.assignPDValue = function (result) {
        console.log(result);

        this.pd_value = result.data.pd;

        this.pdValue.val(result.data.pd);
        this.submitButton.attr('disabled',null);
        //this.container.find(".hs-richtext p").html('Your PD Value is ' + result.data.pd + "mm");

        this.submitButton.click();
    };

    this.handleFlowInterruption = function (result) {
        console.log(result);
        if (result != null && typeof result == 'object' && typeof result.data == 'object' && typeof result.data.pd != 'undefined') {
            this.assignPDValue(result);
        }
    };

    this.handleAnalytics = function(event) {
        console.log(event);

        if (typeof ga === 'function' && typeof event.title !== 'undefined') {
            ga('send', 'event', 'WebPD Tool', event.title , event.description );

            if (typeof lfLogger !== 'undefined') {
                lfLogger.push({
                    'text': 'WebPD Tool',
                    'event': {
                        'title': event.title,
                        'description': event.description,
                        'user': this.firstName.val() + this.lastName.val().substr(0,1)
                    }
                });
            }
        }
    };

    this.handleError = function (error) {
        console.log('could not initialize WebPD tool', error);
    };

    this.showNextStep = function() {
        this.stepTwo.show();
        this.stepOne.hide();
    };

    this.validateEmail = function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    this.updateThankYouMessage = function() {
        var msg = this.container.find('.submitted-message').html();
        msg = msg.replace('(NAME)',this.firstName.val()).replace("(PD_VALUE)", this.pd_value);

        this.container.find('.submitted-message').html(msg);
        this.container.find('.submitted-message a').addClass('Button Button--primary');

        $(".PageContent p, .PageContent h2").hide();
        $(".PageContent .hbspt-form p, .PageContent .go-prescription h2").show();
    };

    this.init();
}
